export default "__VITE_ASSET__DzX2DHKf__"